import axios from 'axios';
import VueNoty from "vuejs-noty";

export default {
    install(Vue, options) {
        if (!options) {
            options = {};
        }

        Vue.use(VueNoty, {
            theme: 'bootstrap-v4',
            timeout: 5000
        });

        Vue.prototype.$noty.ajaxError = (error) => {

            if (error instanceof axios.Cancel) {
                return;
            }

            if (error.response) {

                switch (typeof error.response.data) {
                    case 'string':
                        Vue.noty.error(error.response.data);
                        return;
                    case 'object':
                        if (typeof error.response.data.errors === 'object') {

                            _.forEach(error.response.data.errors, function (value) {
                                Vue.noty.error(value);
                            })

                            return;
                        }
                }

            }

            Vue.noty.error("Oops, something went wrong!");
        }

    }
}
